import { useNavigate } from 'react-router-dom';
import { ChamProjectsOpenButton } from '../../shared/ChamProjects/ChamProjects';
import styles from "./LandingPage.module.css";

export default function LandingPage() {
    const navigate = useNavigate();

    const handleGetStarted = () => {
        navigate('/floorplans');
    };

    return (
        <div className={styles.landingPage}>
            {/* Background image */}
            <div className={styles.carouselContainer}>
                <div
                    className={`${styles.bgImage} ${styles.active}`}
                    style={{ backgroundImage: `url('/images/landing/landing.jpeg')` }}
                />
            </div>

            {/* White info box */}
            <div className={styles.infoBox}>
                <div className={styles.logoIcon}>
                    <img src="/images/landing/u22.png" alt="Logo" />
                </div>
                <h2 className={styles.tagline}>Experience the Difference</h2>
                <h1 className={styles.heading}>Design Studio</h1>
                <p className={styles.description}>
                    Personalize your Atlantic Builders home that reflects your family's lifestyle.
                </p>
            </div>

            {/* Bottom CTA section */}
            <div className={styles.ctaSection}>
                <div className={styles.ctaCard}>
                    <img src="/images/landing/u14.png" alt="Home" className={styles.ctaIcon} />
                    <h3 className={styles.ctaTitle}>Find your home</h3>
                    <button className={styles.ctaButton} onClick={handleGetStarted}>
                        Get Started
                    </button>
                </div>

                <div className={styles.divider} />

                <div className={styles.ctaCard}>
                    <img src="/images/landing/u17.png" alt="Projects" className={styles.ctaIcon} />
                    <h3 className={styles.ctaTitle}>View your Projects</h3>
                    <ChamProjectsOpenButton title="Log In" className={styles.ctaButton} />
                </div>
            </div>
        </div>
    );
}
